import { WORKY_WEB_APP_PATHS } from '../../../WorkyWebAppPaths';
import { isValidString } from '../../../common/CommonUtilsMethods';

const EDIT_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_ID_QUERY_KEY: string = 'checklistTemplateId';

const WORKER_ONBOARDING_CHECKLIST_TEMPLATES_PATH: string =
  WORKY_WEB_APP_PATHS.agencyWorkerOnboardingChecklistTemplates;

const CREATE_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_PATH: string =
  WORKY_WEB_APP_PATHS.agencyWorkerOnboardingChecklistTemplates;

const buildEditWorkerOnboardingChecklistTemplatePath = (checklistTemplateId: string): string => {
  return (
    `${WORKY_WEB_APP_PATHS.agencyWorkerOnboardingChecklistTemplates}`
    + `?${EDIT_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_ID_QUERY_KEY}=${encodeURIComponent(checklistTemplateId)}`
  );
};

const resolveEditWorkerOnboardingChecklistTemplateIdFromQuery = (search: string): string | null => {
  const params: URLSearchParams = new URLSearchParams(search);
  const checklistTemplateId: string | null = params.get(
    EDIT_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_ID_QUERY_KEY
  );
  if (!isValidString(checklistTemplateId)) {
    return null;
  }
  return checklistTemplateId;
};

export {
  EDIT_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_ID_QUERY_KEY,
  WORKER_ONBOARDING_CHECKLIST_TEMPLATES_PATH,
  CREATE_WORKER_ONBOARDING_CHECKLIST_TEMPLATE_PATH,
  buildEditWorkerOnboardingChecklistTemplatePath,
  resolveEditWorkerOnboardingChecklistTemplateIdFromQuery,
};
